// extracted by mini-css-extract-plugin
export var aboveInput = "_jh-0";
export var actionButton = "_jh-5";
export var actionButtonContainer = "_jh-1";
export var actionIcon = "_jh-6";
export var aiInfoContainer = "_jh-2";
export var attachmentWrapper = "_jh-7";
export var bold = "_jh-3";
export var checkIcon = "_jh-8";
export var clickingRecipientBar = "_jh-11";
export var commentThreadSwitch = "_jh-a";
export var draftImage = "_jh-b";
export var draftImageContainer = "_jh-c";
export var draftImages = "_jh-e";
export var editButton = "_jh-g";
export var editor = "_jh-f";
export var editorContainer = "_jh-y";
export var editorErrorTooltipWrapper = "_jh-9";
export var headerDivider = "_jh-h";
export var icon = "_jh-i";
export var info = "_jh-j";
export var internal = "_jh-n";
export var internalDivider = "_jh-k";
export var internalMessage = "_jh-l";
export var messageInputCard = "_jh-m";
export var messageInputForm = "_jh-o";
export var messageInputFormInternal = "_jh-p";
export var options = "_jh-q";
export var publicMessageCustomer = "_jh-s";
export var publicMessageMerchant = "_jh-r";
export var removeImageButton = "_jh-d";
export var replyButtons = "_jh-t";
export var showSignatureButton = "_jh-u";
export var spinner = "_jh-v";
export var verticalButtonDivider = "_jh-4";
export var visibilitySelector = "_jh-w";
export var warning = "_jh-x";
export var wrappingText = "_jh-z";
export var writingInternalNoteTopBorder = "_jh-10";